'use client';

import type { GetStaticProps, NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { ReactElement, ReactNode } from 'react';

import { Chats } from '../modules/Ginger/Chats';
import { defaultlayout } from '../shared/constants/layoutConstant';
import { withMsalAuthentication } from '../shared/hocs/withMsalAuthentication';

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
    getLayout?: (page: ReactElement) => ReactNode;
    layout?: string;
};

const Home: NextPageWithLayout = withMsalAuthentication(() => {
    return <Chats />;
});

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    return {
        props: {
            ...(await serverSideTranslations(locale ?? 'en', [
                'common',
                'footer',
                'ginger',
                'modal',
            ])),
        },
    };
};

Home.layout = defaultlayout;
export default Home;
